module.exports = __webpack_public_path__ + "static/assets/459bb3ff5d293f8effebcce82de35d09.svg";